import ContentIcon from './ContentIcon'

export default ContentIcon
